import Axios from './Axios'
import Uris from './Uris'

export interface ICategory {
  name: string
  color: string
  id?: number
  created?: string
  modified?: string
  slug?: string
}

export const getCategories = async (): Promise<ICategory[]> => {
  const uri = Uris.admin.blog.categories.getAll
  const { results } = await Axios.get(uri)
  return results
}

export const create = async (category: ICategory): Promise<ICategory> => {
  const uri = '/api/blog/categories/'
  return Axios.post(uri, category)
}

export const update = async (id: number, category: ICategory): Promise<ICategory> => {
  const uri = '/api/blog/categories/'
  return Axios.put(`${uri}${id}/`, category)
}

export const remove = async (id: number) => {
  const uri = '/api/blog/categories/'
  return Axios.delete(`${uri}${id}/`)
}
